import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeYoutubeVideo01 from './HomeYoutubeVideo_01';
//import HomeYoutubeVideo02 from './HomeYoutubeVideo_02';

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const pw = useRef({})

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        <>
            {
            layout.current === 'home-video-01' ?
                <HomeYoutubeVideo01 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-video-02' ?
                <HomeYoutubeVideo01 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-video-03' ?
                <HomeYoutubeVideo01 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-video-04' ?
                <HomeYoutubeVideo01 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
                <HomeYoutubeVideo01 pag_welcome={pw.current} dados_config={dados_config.current} />
            }
        </>
    )
}
